async function saGetData() {
    const id = document.querySelector(".store-availability-list").dataset.productId;
    const url = `https://ctl-store-availability.modinity.workers.dev/?id=${id}`;
    console.log("Fetching:", url);

    const res = await fetch(url);
    const json = await res.json();
    console.log("Data Mentah API:", json);

    if (!json.data || !json.data.productVariants) {
        console.error("API error:", json.errors || json);
        return [];
    }
    return json.data.productVariants.edges;
}

const SA_EXCLUDED_KEYWORDS = ["online store", "event", "metro"];

function saIsExcluded(name) {
    const n = name.toLowerCase();
    return SA_EXCLUDED_KEYWORDS.some(k => n.includes(k));
}

function saIsPushed(t, a) {
    return !saIsExcluded(t) && !a.some(x => x.name === t);
}

function saCleanName(t) {
    return t.replace("CTL", "Calla The Label")
}

function saGetAvailabilityStatus(t) {
    return t > 3 ? "Available" : t > 0 ? "Low stock" : "Not available";
}

function saIsVariantAdd(t, a) {
    return a.some((a => a.name === t))
}

function saAddVariant(t, a, e, i) {
    var n = i.findIndex((t => t.name === a));
    const s = {
        available_status: saGetAvailabilityStatus(e),
        quantity: e,
        title: t.node.title,
        id: t.node.id.replace("gid://shopify/ProductVariant/", "")
    };
    i[n].variants.push(s), 
    i[n].quantity = saSumQuantity(e, i[n]), 
    i[n].available = i[n].quantity > 0, 
    i[n].available_status = saGetAvailabilityStatus(i[n].quantity)
}

function saSumQuantity(t, a) {
    return a.quantity + t
}

function saRenderWhatsApp(t, a) {
    return ["metro"].some((a => t.name.toLowerCase().includes(a))) ? "" : `
        <a style="height: 24px;margin-right: 16px;" target=”_blank” href="${saChatWhatsapp(t.clean_name,t.phone,a.title)}">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.749 6.17972C15.3459 4.77481 13.4798 4.00071 11.4915 4C7.39433 4 4.05989 7.33409 4.05846 11.4323C4.05775 12.7424 4.40025 14.0211 5.05067 15.1481L3.99609 19L7.93641 17.9664C9.02198 18.5588 10.2444 18.8706 11.4883 18.871H11.4915C15.5879 18.871 18.9227 15.5365 18.9241 11.4383C18.9248 9.45217 18.1525 7.58499 16.749 6.18007V6.17972ZM11.4915 17.6158H11.489C10.3806 17.6154 9.29322 17.3174 8.3445 16.7547L8.11889 16.6207L5.78057 17.2341L6.40462 14.9542L6.25778 14.7204C5.63944 13.7368 5.31262 12.5998 5.31333 11.4327C5.31476 8.02657 8.0861 5.25523 11.494 5.25523C13.1441 5.25594 14.6951 5.89924 15.8616 7.06715C17.0281 8.2347 17.6699 9.78718 17.6692 11.4376C17.6678 14.8441 14.8965 17.6154 11.4915 17.6154V17.6158ZM14.8801 12.989C14.6944 12.896 13.7813 12.4469 13.6109 12.3849C13.4406 12.3229 13.3169 12.2919 13.1932 12.478C13.0696 12.664 12.7136 13.0824 12.6052 13.2061C12.4969 13.3301 12.3885 13.3454 12.2028 13.2524C12.0172 13.1594 11.4188 12.9634 10.7092 12.3307C10.1571 11.8382 9.78431 11.2302 9.676 11.0442C9.56764 10.8581 9.66459 10.7576 9.75723 10.6653C9.84062 10.5819 9.94292 10.4483 10.0359 10.3399C10.129 10.2316 10.1596 10.1539 10.2216 10.0302C10.2836 9.90619 10.2526 9.79787 10.2063 9.70482C10.16 9.61181 9.78862 8.69764 9.63358 8.32593C9.4828 7.96384 9.32958 8.01302 9.21588 8.00696C9.10753 8.00162 8.98388 8.00055 8.85985 8.00055C8.73582 8.00055 8.53479 8.04688 8.36445 8.23292C8.1941 8.41894 7.71438 8.86836 7.71438 9.78216C7.71438 10.696 8.37979 11.5795 8.4728 11.7035C8.56581 11.8275 9.78252 13.7033 11.6454 14.508C12.0884 14.6994 12.4345 14.8138 12.7043 14.8993C13.1491 15.0408 13.5539 15.0209 13.874 14.9731C14.2307 14.9196 14.9727 14.5237 15.1274 14.0899C15.2821 13.6562 15.2821 13.2841 15.2358 13.2068C15.1895 13.1294 15.0654 13.0827 14.8797 12.9897L14.8801 12.989Z" fill="#4A4A4A"/>
            </svg>
        </a>
    `
}

function saWhatsappUrl(store) {
    const title = document.querySelector(".store-availability-list").dataset.productTitle;
    const phone = (store.phone || "").replace(/[^0-9]/g, "");
    return `https://wa.me/${phone}?text=${encodeURIComponent(`Halo ${store.clean_name}, apakah ${title} masih tersedia? Terima kasih`)}`;
}

function saHideContact(store) {
    return ["metro"].some(k => store.name.toLowerCase().includes(k));
}

function saMutateData(t) {
    let a = [];
    return t.forEach((t => {
        t.node.inventoryItem.inventoryLevels.edges.forEach((e => {
            if (e.node.location.isActive === false) return;

            if (saIsPushed(e.node.location.name, a)) {
                const i = {
                    name: e.node.location.name,
                    clean_name: saCleanName(e.node.location.name),
                    available: e.node.quantities[0].quantity > 0,
                    available_status: saGetAvailabilityStatus(e.node.quantities[0].quantity),
                    quantity: e.node.quantities[0].quantity,
                    address: e.node.location.address.address1,
                    phone: e.node.location.address.phone,
                    variants: [{
                        available_status: saGetAvailabilityStatus(e.node.quantities[0].quantity),
                        quantity: e.node.quantities[0].quantity,
                        title: t.node.title,
                        id: t.node.id.replace("gid://shopify/ProductVariant/", "")
                    }]
                };
                a.push(i)
            } else saIsVariantAdd(e.node.location.name, a) && saAddVariant(t, e.node.location.name, e.node.quantities[0].quantity, a)
        }))
    })), a
}

let saLoading = false;

function saToggleModal() {
    const modal = document.querySelector(".store-availability-modal"),
          body = document.querySelector("body");
    const opening = modal.dataset.modal !== "open";

    modal.dataset.modal = opening ? "open" : "";
    body.classList.toggle("stop-scrolling", opening);

    const menu = document.querySelector(".store-availability-menu");
    if (opening && menu.dataset.loaded !== "true" && !saLoading) {
        saLoading = true;
        saInitStoreAvailability().finally(() => { saLoading = false; });
    }
}

function saToggleAccordion(t) {
    const a = this.parentNode;
    a.dataset.accordion = "open" == a.dataset.accordion ? "" : "open"
}

function saSearchStore(t) {
    const keyword = t.value.toLowerCase();
    const activeBtn = document.querySelector(".store-availability-header__variant-picker button[data-state='active']");
    const activeVariantId = activeBtn ? activeBtn.dataset.id : null;

    document.querySelectorAll(".store-availability-store").forEach((a => {
        const statusEl = activeVariantId ? a.querySelector(`.store-availability-store__status[data-id='${activeVariantId}']`) : null;
        
        const isAvailable = statusEl && statusEl.dataset.available !== "Not available";

        if (isAvailable && a.dataset.store.toLowerCase().includes(keyword)) {
            a.classList.remove("hidden");
        } else {
            a.classList.add("hidden");
        }
    }));
    const visible = document.querySelectorAll(".store-availability-store:not(.hidden)").length;
    const searchEmpty = document.getElementById("sa-search-empty");
    if (searchEmpty) {
        searchEmpty.classList.toggle("hidden", visible > 0 || !keyword);
    }
}

function saChatWhatsapp(t, a, e) {
    const i = document.querySelector(".store-availability-list").dataset.productTitle,
          n = "default title" == e.toLowerCase() ? "" : `- ${e} `;
    return `https://wa.me/${a}?text=${encodeURI(`Halo ${t}, apakah ${i} ${n}masih tersedia? Terima kasih`)}`
}

function saChatWhatsapp2(t) {
    t.preventDefault();
    const a = t.target.dataset.store,
          e = t.target.dataset.phone,
          i = document.querySelector(".store-availability-list").dataset.productTitle,
          n = document.querySelector(".store-availability-list").dataset.variantTitle;
    let s = "";
    const o = JSON.parse(document.getElementById("variants-for-availability").textContent),
          l = window.location.search,
          r = new URLSearchParams(l);
    
    if (r.has("variant")) {
        const t = r.get("variant"),
              a = o.findIndex((a => a.id == t));
        s = `- ${o[a].title} `
    } else s = "default title" == n.toLowerCase() ? "" : `- ${n} `;
    
    const d = `Halo ${a}, apakah ${i}${s}masih tersedia? Terima kasih`;
    window.open(`https://wa.me/${e}?text=${encodeURI(d)}`)
}

function saPickVariant() {
    const variantId = event.target.dataset.id;

    event.target.dataset.state = "active", 
    event.target.parentNode.querySelectorAll(`button:not([data-id='${variantId}'])`).forEach((t => {
        t.dataset.state = "";
    }));
    
    let availableStoresCount = 0;

    document.querySelectorAll(`.store-availability-store`).forEach(store => {
        const statusEl = store.querySelector(`.store-availability-store__status[data-id='${variantId}']`);
        
        if (statusEl) {
            store.querySelectorAll('.store-availability-store__status').forEach(s => {
                if (s === statusEl) {
                    s.classList.remove('hidden');
                } else {
                    s.classList.add('hidden');
                }
            });

            if (statusEl.dataset.available === "Not available") {
                store.classList.add("hidden");
            } else {
                store.classList.remove("hidden");
                availableStoresCount++;
            }
        } else {
            store.classList.add("hidden");
        }
    });

    const emptyStateEl = document.getElementById("sa-empty-state");
    const searchEmptyEl = document.getElementById("sa-search-empty");
    const searchInput = document.querySelector(".store-availability-search input");
    
    if (searchInput) searchInput.value = "";
    if (searchEmptyEl) searchEmptyEl.classList.add("hidden");

    if (emptyStateEl) {
        if (availableStoresCount === 0) {
            emptyStateEl.classList.remove("hidden");
            if (searchInput) searchInput.disabled = true;
        } else {
            emptyStateEl.classList.add("hidden");
            if (searchInput) searchInput.disabled = false;
        }
    }
}

async function saInitStoreAvailability() {
    return saGetData().then((t => {
        const a = saMutateData(t),
              e = document.querySelector(".store-availability-list");
        let i = "";
        a.forEach((t => {
            let a = "";
            t.variants.forEach((v => {
                a += `
              <div class="store-availability-store__status" data-available="${v.available_status}" data-id="${v.id}">
                <div class="icon-dot"></div>
                <span>${v.available_status}</span>
              </div>
            `;
            }));
            i += `<div class="store-availability-store" data-available="${t.available_status}" data-store="${t.clean_name}">
                <div class="store-availability-store__header">
                  <h3>${t.clean_name}</h3>
                    <svg width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0790874 0.0839177C0.104094 0.0573169 0.1338 0.0362121 0.166505 0.021812C0.19921 0.00741204 0.234271 0 0.26968 0C0.305089 0 0.340151 0.00741204 0.372856 0.021812C0.405561 0.0362121 0.435267 0.0573169 0.460274 0.0839177L3.50007 3.30995L6.53987 0.0839177C6.5649 0.05736 6.59461 0.0362931 6.62731 0.0219202C6.66001 0.00754724 6.69506 0.000149552 6.73046 0.000149552C6.76586 0.000149552 6.80091 0.00754724 6.83361 0.0219202C6.86631 0.0362931 6.89603 0.05736 6.92105 0.0839177C6.94608 0.110475 6.96594 0.142004 6.97948 0.176703C6.99303 0.211403 7 0.248594 7 0.286152C7 0.32371 6.99303 0.360901 6.97948 0.3956C6.96594 0.4303 6.94608 0.461828 6.92105 0.488386L3.69066 3.91608C3.66566 3.94268 3.63595 3.96379 3.60325 3.97819C3.57054 3.99259 3.53548 4 3.50007 4C3.46466 4 3.4296 3.99259 3.3969 3.97819C3.36419 3.96379 3.33448 3.94268 3.30948 3.91608L0.0790874 0.488386C0.0540178 0.461852 0.0341279 0.430332 0.0205568 0.395629C0.00698564 0.360926 0 0.323724 0 0.286152C0 0.24858 0.00698564 0.211377 0.0205568 0.176675C0.0341279 0.141972 0.0540178 0.110451 0.0790874 0.0839177Z" fill="#21272A"/>
                    </svg>
                </div>
                ${a}
                <div class="store-availability-store__accordion">
                  <p>${t.address}</p>
                  <hr>
                  <div class="store-availability-store__link">
                    <a class="sa-action" target="_blank" rel="noopener" href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(t.clean_name)}">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.6668 8.33329C16.6668 12.0152 10.0002 18.3333 10.0002 18.3333C10.0002 18.3333 3.3335 12.0152 3.3335 8.33329C3.3335 4.65139 6.31826 1.66663 10.0002 1.66663C13.6821 1.66663 16.6668 4.65139 16.6668 8.33329Z" stroke="#21272A" stroke-width="0.5"/>
                        <path d="M9.99984 9.16667C10.4601 9.16667 10.8332 8.79358 10.8332 8.33333C10.8332 7.8731 10.4601 7.5 9.99984 7.5C9.53959 7.5 9.1665 7.8731 9.1665 8.33333C9.1665 8.79358 9.53959 9.16667 9.99984 9.16667Z" fill="#21272A" stroke="#21272A" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      <span class="sa-action__text">Direction</span>
                    </a>
                    ${saHideContact(t) ? "" : `
                    <span class="sa-divider"></span>
                    <a class="sa-action" target="_blank" rel="noopener" href="${saWhatsappUrl(t)}">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2620_945)">
                        <path d="M2.5 17.5L3.875 14.3333C2.82305 12.84 2.35222 11.0142 2.55087 9.1984C2.74952 7.38262 3.60399 5.70176 4.95392 4.47124C6.30386 3.24073 8.05646 2.54515 9.88282 2.51506C11.7092 2.48496 13.4837 3.12241 14.8735 4.30778C16.2632 5.49316 17.1726 7.14496 17.431 8.9532C17.6893 10.7614 17.2789 12.6018 16.2768 14.129C15.2746 15.6561 13.7495 16.765 11.9878 17.2476C10.2261 17.7301 8.34885 17.5532 6.70833 16.75L2.5 17.5Z" stroke="#21272A" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.5 8.33337C7.5 8.44388 7.5439 8.54986 7.62204 8.628C7.70018 8.70614 7.80616 8.75004 7.91667 8.75004C8.02717 8.75004 8.13315 8.70614 8.21129 8.628C8.28943 8.54986 8.33333 8.44388 8.33333 8.33337V7.50004C8.33333 7.38953 8.28943 7.28355 8.21129 7.20541C8.13315 7.12727 8.02717 7.08337 7.91667 7.08337C7.80616 7.08337 7.70018 7.12727 7.62204 7.20541C7.5439 7.28355 7.5 7.38953 7.5 7.50004V8.33337ZM7.5 8.33337C7.5 9.43844 7.93899 10.4983 8.72039 11.2797C9.50179 12.0611 10.5616 12.5 11.6667 12.5M11.6667 12.5H12.5C12.6105 12.5 12.7165 12.4561 12.7946 12.378C12.8728 12.2999 12.9167 12.1939 12.9167 12.0834C12.9167 11.9729 12.8728 11.8669 12.7946 11.7887C12.7165 11.7106 12.6105 11.6667 12.5 11.6667H11.6667C11.5562 11.6667 11.4502 11.7106 11.372 11.7887C11.2939 11.8669 11.25 11.9729 11.25 12.0834C11.25 12.1939 11.2939 12.2999 11.372 12.378C11.4502 12.4561 11.5562 12.5 11.6667 12.5Z" stroke="#21272A" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_2620_945">
                        <rect width="20" height="20" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>
                      <span class="sa-action__text">Contact Store</span>
                    </a>`}
                  </div>
                </div>
              </div>`;
        }));
        e.innerHTML = i + `<div id="sa-empty-state" class="hidden">The selected variant <span class="stock-empty">is out of stock</span> across all store locations.</div>` + `<div id="sa-search-empty" class="hidden">No store matches your search</div>`;
    })).then((() => {
        document.querySelectorAll(".store-availability-store__header").forEach((t => {
            t.addEventListener("click", saToggleAccordion)
        }));
        document.querySelector(".store-availability-header__variant-picker button").click();
        document.querySelector(".store-availability-menu").dataset.loaded = "true";
        const l = document.getElementById("sa-loading");
        if (l) l.remove();
    }))
}